/* eslint-disable no-unused-expressions */
import React, { Component } from 'react'
import axios from 'axios'
import Icon from 'react-icons-kit'
import { upload } from 'react-icons-kit/fa/upload'
import onlyLoggedIn from './onlyLoggedIn'
import { connect } from 'react-redux'
import ReactGA from 'react-ga'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import './VideoUpload.css'


let humanFileSize = size => {
    var i = Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

class VideoUpload extends Component {
    state = {
        title: '',
        uploadPercent: 0,
        uploadSpeed: 0,
        processing: false,
        category: 'Yoga Pants',
        video_selected: false,
        disabled: false,
        tags: ''
    }

    uploadVideo = e => {
        e.preventDefault()
        this.setState({ processing: true })
        let { title, category, tags} = this.state
        let data = new FormData()
        let file = this.fileInput.files[0]
        data.append('file', file)
        data.append('title', title)
        data.append('category', category)
        data.append('tags', tags)

        let start_time = performance.now()
        let last_loaded = 0
        axios.post('/api/upload_video', data, {
            onUploadProgress: progressEvent => {
                let duration = (performance.now() - start_time) / 1000
                let loaded = progressEvent.loaded - last_loaded
                let uploadSpeed = loaded / duration
                last_loaded = progressEvent.loaded
                start_time = performance.now()

                let uploadPercent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                this.setState({ uploadPercent, uploadSpeed })
                NProgress.set(progressEvent.loaded / progressEvent.total)
            }
        })
            .then(r => {
                let { short_code } = r.data
                this.props.history.push(`/video_status/${short_code}`)
            })
            .catch(e => this.setState({ error: e.response.data.message, disabled: false }))
            .finally(r => {
                this.setState({ processing: false })
                NProgress.done(true)
                ReactGA.event({
                    category: 'Video',
                    action: 'Uploaded Video'
                })
            })
    }

    setCategory = category => this.setState({category})

    render() {
        let { error, uploadPercent, uploadSpeed, processing, category, disabled, title, tags, video_selected } = this.state
        let isInvalid = title == '' || !video_selected
        disabled = disabled || processing || isInvalid

        return <form className='upload_video card' onSubmit={this.uploadVideo}>
            <h2>Upload Video</h2>
            <input className='upload_video_title' type="text" placeholder="Title (required)" value={title} onChange={e => this.setState({ title: e.target.value })} />
            <input className='upload_video_title' type="text" placeholder="comma seperated list of tags (optional)" value={tags} onChange={e => this.setState({ tags: e.target.value })} />
            <FormControl variant="outlined" className={'category_selector'}>
                <InputLabel>
                    Category
                </InputLabel>
                <Select
                    value={category}
                    onChange={e => this.setCategory(e.target.value)}
                    labelWidth={68}
                >
                    <MenuItem value={'Yoga Pants'}>Yoga Pants</MenuItem>
                    <MenuItem value={'Tight Jeans'}>Tight Jeans</MenuItem>
                    <MenuItem value={'Beach/Bikini'}>Beach/Bikini</MenuItem>
                    <MenuItem value={'Short Shorts'}>Short Shorts</MenuItem>
                    <MenuItem value={'Cleavage'}>Cleavage</MenuItem>
                    <MenuItem value={'Feet'}>Feet</MenuItem>
                    <MenuItem value={'Tight Dress'}>Tight Dress</MenuItem>
                </Select>
            </FormControl>
            <input type="file" accept='video/*' ref={i => this.fileInput = i} name='video' onChange={() => this.setState({ video_selected: true })} />

            <button type="submit" className='custom_btn' disabled={disabled}>
                {processing
                    ? <div className='video_upload_button'>{uploadPercent}%&emsp;<Icon size={20} icon={upload} /></div>
                    : <div>Upload Video&emsp;<Icon size={20} icon={upload} /></div>}
            </button>
            {processing && <div className='upload_speed'>{humanFileSize(uploadSpeed)}/s</div>}

            {error && <p style={{ color: 'red' }}>{error}</p>}
        </form>
    }
}

const mapStateToProps = state => ({
    access_token: state.access_token
})

export default onlyLoggedIn(connect(mapStateToProps)(VideoUpload))